import React, { useEffect, useCallback } from "react";
import mqtt_topics from "../../../mqtt/mqtt_topics";
import { useStateIfMounted } from "use-state-if-mounted";

const api_key = "45442c85d6ae4aa69a4132253230903";
const REFRESH_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

const Forecast = () => {
  const [weatherData, setWeatherData] = useStateIfMounted(null);
  const [status, setStatus] = useStateIfMounted("loading"); // "loading" | "success" | "error"

  let location = "Lebanon";
  if (
    mqtt_topics.latitude != undefined &&
    mqtt_topics.latitude != "" &&
    mqtt_topics.longitude != undefined &&
    mqtt_topics.longitude != ""
  ) {
    location = mqtt_topics.latitude + "," + mqtt_topics.longitude;
  }

  const fetchData = useCallback(async () => {
    try {
      const response = await fetch(
        "https://api.weatherapi.com/v1/astronomy.json?key=" +
          api_key +
          "&q=" +
          encodeURIComponent(location),
      );

      let data = null;
      try {
        data = await response.json();
      } catch (parseError) {
        data = null;
      }

      if (!response.ok || data == null || data.error != undefined) {
        setWeatherData(null);
        setStatus("error");
        return;
      }

      setWeatherData(data);
      setStatus("success");
    } catch (error) {
      console.error("Forecast fetch failed:", error);
      setWeatherData(null);
      setStatus("error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    fetchData(); // Initial fetch

    const intervalId = setInterval(fetchData, REFRESH_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, [fetchData]);

  const convertTo12HourFormat = (time24) => {
    const parts = time24.split(":");
    const hours = parts[0];
    const minutes = parts[1];
    let period = "AM";
    let hours12 = parseInt(hours, 10);

    if (hours12 === 0) {
      hours12 = 12;
    } else if (hours12 === 12) {
      period = "PM";
    } else if (hours12 > 12) {
      hours12 -= 12;
      period = "PM";
    }

    const formattedHours = hours12 < 10 ? "0" + hours12 : "" + hours12;
    return formattedHours + ":" + minutes + " " + period;
  };

  if (status === "loading") {
    return (
      <div style={styles.row} title="Astronomy data">
        <span style={styles.spinner} />
        <span style={styles.muted}>Loading forecast…</span>
      </div>
    );
  }

  // Guard against error state AND any inconsistent/missing data shape,
  // without relying on optional chaining.
  if (
    status !== "success" ||
    weatherData == null ||
    weatherData.location == undefined ||
    weatherData.location.localtime == undefined ||
    weatherData.astronomy == undefined ||
    weatherData.astronomy.astro == undefined
  ) {
    return null;
  }

  const loc = weatherData.location;
  const astronomy = weatherData.astronomy;
  const localtimeParts = loc.localtime.split(" ");
  const timePart = localtimeParts.length > 1 ? localtimeParts[1] : null;

  return (
    <div style={styles.row} title="Astronomy data">
      {timePart != null && (
        <React.Fragment>
          <span style={styles.item}>
            <span style={styles.muted}>Now</span>{" "}
            {convertTo12HourFormat(timePart)}
          </span>
          <span style={styles.divider}>•</span>
        </React.Fragment>
      )}

      <span style={styles.item}>
        <span aria-hidden="true">🌅</span> {astronomy.astro.sunrise}
      </span>

      <span style={styles.divider}>•</span>

      <span style={styles.item}>
        <span aria-hidden="true">🌇</span> {astronomy.astro.sunset}
      </span>
    </div>
  );
};

const styles = {
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "0.5rem",
    marginTop: "0.35rem",
    fontSize: "0.8rem",
    opacity: 0.85,
  },
  item: {
    display: "inline-flex",
    alignItems: "center",
    gap: "0.3rem",
    whiteSpace: "nowrap",
  },
  divider: {
    opacity: 0.4,
  },
  muted: {
    opacity: 0.75,
  },
  spinner: {
    width: "0.8rem",
    height: "0.8rem",
    borderRadius: "50%",
    border: "2px solid rgba(255,255,255,0.3)",
    borderTopColor: "currentColor",
    animation: "weather-spin 0.8s linear infinite",
  },
};

export default Forecast;
